/**
 * Environment utility functions
 * Centralized location for environment-related checks
 *
 * Note: In Next.js, NODE_ENV is automatically available on both client and server,
 * but other env vars need NEXT_PUBLIC_ prefix for client-side access.
 */

/**
 * Check if the application is running in production environment
 * @returns {boolean} true if in production, false otherwise
 */
export function isProd() {
  // NODE_ENV is special - available on both client and server in Next.js
  return process.env.NODE_ENV === 'production';
}

/**
 * Check if the application is running in development environment
 * @returns {boolean} true if in development, false otherwise
 */
export function isDev() {
  return process.env.NODE_ENV === 'development';
}

/**
 * Check if the application is running in test environment
 * @returns {boolean} true if in test, false otherwise
 */
export function isTest() {
  return process.env.NODE_ENV === 'test';
}

/**
 * Get the current environment name
 * @returns {string} The current environment (production, development, test)
 */
export function getEnvironment() {
  return process.env.NODE_ENV || 'development';
}

/**
 * Check if we're running on the client side (browser)
 * @returns {boolean} true if on client side, false if on server side
 */
export function isClient() {
  return typeof window !== 'undefined';
}

/**
 * Check if we're running on the server side
 * @returns {boolean} true if on server side, false if on client side
 */
export function isServer() {
  return typeof window === 'undefined';
}
